import { authGet, authSet } from '../utils/request';
import { METHOD_PATCH, METHOD_POST } from '../constants/api';

const baseUrl = '/co/supplier-orders';

export const getSupplierOrderSettings = () => authGet(`${baseUrl}/settings`)
  .then(({ data }) => data);

export const updateSupplierOrderSettings = (recipient) => authSet(
  METHOD_PATCH,
  `${baseUrl}/settings`,
  recipient
);

export const getSupplierAvailability = (item) => authSet(
  METHOD_POST,
  `${baseUrl}/availability`,
  item
);

export const createSupplierQuote = (data) => authSet(
  METHOD_POST,
  `${baseUrl}/quote`,
  data
);

export const placeSupplierOrder = (data) => authSet(
  METHOD_POST,
  `${baseUrl}/place`,
  data
);
